var domainUrl = document.getElementById("site-url").innerText;

window.onload = function() {
    domainUrl = document.getElementById("site-url").innerText;
    if (window.jQuery) {
        // console.log("jquery present");
    } else {
        var jquery_script = document.createElement("script"); 
        jquery_script.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js";  
        document.getElementsByTagName('head')[0].appendChild(jquery_script);        
    }
    var shopify_script = document.createElement("script"); 
    shopify_script.src = "https://cdn.shopify.com/s/shopify/api.jquery.js";
    document.getElementsByTagName('head')[0].appendChild(shopify_script);
}

// Setting count for add all to cart products
var addToCartCount;

// ADD ALL TO CART LINK
var addWorkToCartLink;
var addBasicToCartLink;
var addAllToCartLink;

var url_string = window.location.href;
var url = new URL(url_string);
var products;
let selected_pdt;
var imgid = url.searchParams.get("id");
var resp_id = url.searchParams.get("resp_id");

var language_isocode = document.getElementById("site-iso-code").innerText;
var default_addToCartText = "Add to cart";
var default_addedToCartText = "Added to Cart!";
let outOfStock = "Out of Stock";

switch (language_isocode) {
    case "es":
        default_addToCartText = "Añadir a la cesta";
        default_addedToCartText = "¡Añadido al carrito!";
        outOfStock = "Agotado";
        break;

    case "it":
        default_addToCartText = "Aggiungi al carrello";
        default_addedToCartText = "Aggiunto al carrello!";
        outOfStock = "esaurito";
        break;

    case "fr":
        default_addToCartText = "Ajouter au panier";
        default_addedToCartText = "Ajouté au panier!";
        outOfStock = "rupture de stock";
        break;

    case "de":
        default_addToCartText = "In den Warenkorb legen";
        default_addedToCartText = "Zum Warenkorb hinzugefügt!";
        outOfStock = "ausverkauft";
        break;

    case "ja":
        default_addToCartText = "カートに追加";
        default_addedToCartText = "カートに追加されました!";
        outOfStock = "在庫切れ";
        break;

    case "ko":
        default_addToCartText = "카트에 추가하십시오";
        default_addedToCartText = "장바구니에 담았습니다!";
        outOfStock = "품절";
        break;

    case "pl":
        default_addToCartText = "Dodaj do koszyka";
        default_addedToCartText = "Dodano do koszyka!";
        outOfStock = "obecnie brak na stanie";
        break;

    case "pt":
        default_addToCartText = "Adicionar ao carrinho";
        default_addedToCartText = "Adicionado ao carrinho!";
        outOfStock = "fora de estoque";
        break;

    case "ru":
        default_addToCartText = "Добавить в корзину";
        default_addedToCartText = "Добавлено в корзину!";
        outOfStock = "распродано";
        break;

    case "da":
        default_addToCartText = "Tilføj til kurv";
        default_addedToCartText = "Tilføjet til indkøbskurv";
        outOfStock = "Udsolgt";
        break;

    default:
        default_addToCartText = "Add to cart";
        default_addedToCartText = "Added to Cart";
        outOfStock = "Out of Stock";
}


var domainCurrency;

// Default url path for product
var variant_product_url;

var product_options_map = {};

var option1array = [];
var option2array = [];
var option3array = [];

var option1_ele_arr = [];
var option2_ele_arr = [];
var option3_ele_arr = [];

var variants_div;
var variantOption1_div;
var variantOption2_div;
var variantOption3_div;

// Options name mapped to variant id
var option2_variant_map = {};

const el = (sel, par) => (par || document).querySelector(sel);
const elPopup = el("#tangent-popup-msg");
const elPopupCondtion = el("#tangent-popup-msg-condition");

var upsell_products;

var allToCart;

var all_product_element;

var all_product_array = [];

var all_tags;


if (resp_id != null) {

    var checkout_url =
        "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" +
        resp_id +
        "&self_serve=true&multiple_variants=true";

    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {

        if (xmlhttp.readyState == XMLHttpRequest.DONE) {

            if (xmlhttp.status == 200) {

                try {

                    var jsonData = JSON.parse(xmlhttp.responseText);

                    /*
                     * ONLY jsonData.products is used.
                     * No product section rendering is done.
                     */
                    products = jsonData.products || [];

                    domainCurrency =
                        document.getElementById("site-currency").innerText;

                    if (domainCurrency == "") {
                        domainCurrency = "$";
                    }


                    /*
                     * SELFIE
                     */
                    var selfieDiv =
                        document.getElementById("tangent_selfie_div");

                    var selfieImg =
                        document.getElementById("selfie_img");

                    if (selfieDiv) {
                        selfieDiv.style.display = "flex";
                    }

                    if (selfieImg && jsonData.selfie_url) {

                        selfieImg.src =
                            jsonData.selfie_url;

                        selfieImg.style.display = "";
                    }

                    if (!jsonData.selfie_url) {

                        var tangentImgContainer =
                            document.getElementById("tangent-img-container");

                        if (tangentImgContainer) {
                            tangentImgContainer.style.display = "none";
                        }

                        if (selfieImg) {
                            selfieImg.style.display = "none";
                        }
                    }


                    /*
                     * DESCRIPTION
                     */
                    var checkoutDescription =
                        document.getElementById(
                            "tangent-checkout-description"
                        );

                    var generalText =
                        document.getElementById(
                            "tangent-general-text"
                        );

                    if (
                        jsonData.description != null &&
                        jsonData.description != ""
                    ) {

                        if (checkoutDescription) {

                            checkoutDescription.style.display =
                                "block";

                            checkoutDescription.innerHTML =
                                jsonData.description;
                        }

                    }
                    else if (generalText) {

                        generalText.style.display =
                            "block";
                    }


                    /*
                     * SHOW ONLY ALL PRODUCTS
                     */
                    var allTab =
                        document.getElementById("all");

                    var allProducts =
                        document.getElementById("all-products");

                    var tabWrapper =
                        document.getElementById("tab-wrapper");

                    if (allTab) {
                        allTab.classList.add("active");
                    }

                    if (allProducts) {
                        allProducts.style.display = "flex";
                    }

                    if (tabWrapper) {
                        tabWrapper.style.display = "block";
                    }


                    /*
                     * HIDE BASIC AND WORK
                     */
                    var basicProducts =
                        document.getElementById("basic-products");

                    var workProducts =
                        document.getElementById("work-products");

                    if (basicProducts) {
                        basicProducts.style.display = "none";
                    }

                    if (workProducts) {
                        workProducts.style.display = "none";
                    }


                    /*
                     * ADD ALL BUTTONS
                     */
                    var basicAddAll =
                        document.getElementById(
                            "tangent-add-all-to-cart-basic"
                        );

                    var workAddAll =
                        document.getElementById(
                            "tangent-add-all-to-cart-work"
                        );

                    var allAddAll =
                        document.getElementById(
                            "tangent-add-all-to-cart-all"
                        );

                    if (basicAddAll) {
                        basicAddAll.style.display = "none";
                    }

                    if (workAddAll) {
                        workAddAll.style.display = "none";
                    }

                    if (allAddAll) {
                        allAddAll.style.display = "block";
                    }


                    allToCart =
                        domainUrl +
                        "/cart/add?id[]=";

                    basicCart =
                        domainUrl +
                        "/cart/add?id[]=";

                    workCart =
                        domainUrl +
                        "/cart/add?id[]=";


                    /*
                     * RENDER PRODUCTS
                     *
                     * IMPORTANT:
                     * selected_variants comes from jsonData,
                     * NOT from products.
                     */
                    renderAllProducts(
                        jsonData.selected_variants
                    );


                    console.log(
                        "Products rendered successfully:",
                        products.length
                    );

                }
                catch (error) {

                    console.log(
                        "Error parsing Tangent recommendation response:",
                        error
                    );

                    var errorText =
                        document.getElementById(
                            "tangent-general-text"
                        );

                    if (errorText) {

                        errorText.innerHTML =
                            "Unable to load recommendations. Please retry!";

                        errorText.style.display =
                            "block";
                    }
                }
            }

            else if (xmlhttp.status == 400) {

                console.log(
                    "There was an error 400"
                );
            }

            else {

                console.log(
                    "Something else other than 200 was returned",
                    xmlhttp.status
                );
            }
        }
    };

    xmlhttp.open(
        "GET",
        checkout_url,
        true
    );

    xmlhttp.send();
}


/*
 * ADD PRODUCT TO ALL PRODUCTS UI
 */
function addToAll(pid, html, ele_map) {

    if (
        !all_product_array.includes(
            String(pid)
        )
    ) {

        all_product_array.push(
            String(pid)
        );

        if (all_product_element) {

            all_product_element.insertAdjacentHTML(
                "beforeend",
                html
            );
        }

        return true;
    }

    return false;
}


/*
 * RENDER ALL PRODUCTS
 */
function renderAllProducts(selectedVariants) {

    all_product_array = [];

    all_product_element =
        document.getElementById(
            "all-products-grid"
        );

    if (!all_product_element) {

        console.log(
            "all-products-grid not found"
        );

        return;
    }

    all_product_element.innerHTML = "";

    selected_pdt = {};

    option2_variant_map = {};


    if (
        !products ||
        products.length === 0
    ) {

        var noProducts =
            document.getElementById(
                "tangent-general-text"
            );

        if (noProducts) {

            noProducts.innerHTML =
                "No products found. Please retry!";

            noProducts.style.display =
                "block";
        }

        return;
    }


    var cartIds = [];


    /*
     * LOOP THROUGH EVERY PRODUCT
     */
    for (
        var p = 0;
        p < products.length;
        p++
    ) {

        var product =
            products[p];


        /*
         * Skip invalid products
         */
        if (
            !product ||
            !product.variants ||
            product.variants.length === 0
        ) {
            continue;
        }


        /*
         * GET SELECTED VARIANT
         */
        var selectedVariantIds =
            isSelectedVariantPresent(
                selectedVariants,
                product.id
            );

        var variant =
            product.variants[0];


        if (
            selectedVariantIds.length > 0
        ) {

            for (
                var v = 0;
                v < product.variants.length;
                v++
            ) {

                if (
                    String(
                        product.variants[v].id
                    ) ===
                    String(
                        selectedVariantIds[0]
                    )
                ) {

                    variant =
                        product.variants[v];

                    break;
                }
            }
        }


        /*
         * SAVE SELECTED VARIANT
         */
        selected_pdt[product.id] =
            String(
                variant.id
            );


        /*
         * PRODUCT IMAGE
         */
        var imgsrc =
            getVariantImage(
                variant.image_id,
                product
            );


        /*
         * PRODUCT URL
         */
        var productUrl =
            domainUrl +
            "/products/" +
            product.handle +
            "?variant=" +
            variant.id;


        /*
         * AVAILABILITY
         */
        var available =
            product.status == "active" &&
            isVariantAvailable(
                variant
            );


        var buttonText =
            available
                ? default_addToCartText
                : outOfStock;


        var disableClass =
            available
                ? ""
                : " disable-btn-wrapper";


        /*
         * ESCAPE PRODUCT DATA
         */
        var productTitle =
            escapeHtml(
                product.title || ""
            );

        var productImage =
            escapeHtml(
                imgsrc || ""
            );

        var safeProductUrl =
            escapeHtml(
                productUrl
            );


        /*
         * VARIANT TITLE
         */
        var variantTitle =
            variant.title &&
            variant.title != "Default Title"

                ?

                '<p class="tangent-variant-title tangent_variant_title_text">' +
                    '<b>' +
                        escapeHtml(
                            variant.title
                        ) +
                    '</b>' +
                '</p>'

                :

                "";


        /*
         * PRODUCT CARD HTML
         */
        var productHtml =

            '<div class="tangent-product-card">' +

                '<a ' +
                    'id="all_url_tangent_product_' +
                    product.id +
                    '" ' +
                    'class="tangent-text-link" ' +
                    'target="_blank" ' +
                    'href="' +
                    safeProductUrl +
                    '">' +

                    '<img ' +
                        'id="all_image_tangent_product_' +
                        product.id +
                        '" ' +
                        'src="' +
                        productImage +
                        '" ' +
                        'class="tangent_product_image" ' +
                        'alt="' +
                        productTitle +
                        '">' +

                    '<p class="tangent-product-title tangent_product_title_text">' +
                        '<b>' +
                            productTitle +
                        '</b>' +
                    '</p>' +

                    variantTitle +

                    '<p ' +
                        'id="all_price_tangent_product_' +
                        product.id +
                        '" ' +
                        'class="tangent_product_price_text">' +
                        domainCurrency +
                        variant.price +
                    '</p>' +

                '</a>' +


                /*
                 * VARIANT SELECTOR CONTAINER
                 */
                '<div ' +
                    'id="all_tangent_product_' +
                    product.id +
                '"></div>' +


                /*
                 * ADD TO CART
                 */
                '<a ' +
                    'class="tangent-product-add-btn-wrapper' +
                    disableClass +
                    '" ' +
                    'id="all_cart_tangent_product_' +
                    product.id +
                    '" ' +
                    'onclick="addToCart(' +
                    product.id +
                    ',3)" ' +
                    'href="javascript:void(0)">' +

                    '<p ' +
                        'class="tangent-btn-add tangent_add_to_cart_button" ' +
                        'id="all_cart_tangent_product_' +
                        product.id +
                        '_text">' +

                        buttonText +

                    '</p>' +

                '</a>' +

            '</div>';


        /*
         * ADD PRODUCT TO UI
         */
        addToAll(
            product.id,
            productHtml,
            {}
        );


        /*
         * ADD AVAILABLE PRODUCT
         * TO ADD-ALL CART
         */
        if (available) {

            cartIds.push(
                variant.id
            );
        }


        /*
         * CREATE VARIANT SELECTOR
         */
        if (
            product.variants.length > 1
        ) {

            createVariantSelector(
                product,
                variant
            );
        }
    }


    /*
     * UPDATE ADD ALL CART
     */
    updateAllProductsCart(
        cartIds
    );


    /*
     * ATTACH VARIANT EVENTS
     */
    var options =
        document.getElementsByClassName(
            "tangent_option"
        );


    for (
        var o = 0;
        o < options.length;
        o++
    ) {

        options[o].addEventListener(
            "click",
            function() {

                changePdtVariant(
                    this
                );

            },
            false
        );
    }


    console.log(
        "All products rendered:",
        products.length
    );
}


/*
 * UPDATE ADD ALL CART URL
 */
function updateAllProductsCart(cartIds) {

    if (!cartIds) {
        cartIds = [];
    }


    addToCartCount =
        cartIds.length;


    if (cartIds.length > 0) {

        addAllToCartLink =
            domainUrl +
            "/cart/add?id[]=" +
            cartIds.join(
                "&id[]="
            );

    }
    else {

        addAllToCartLink =
            "";
    }


    var addAllButton =
        document.getElementById(
            "tangent-add-all-to-cart-all"
        );


    if (addAllButton) {

        if (addAllToCartLink) {

            addAllButton.setAttribute(
                "href",
                addAllToCartLink
            );

        }
        else {

            addAllButton.removeAttribute(
                "href"
            );
        }
    }
}


/*
 * CREATE VARIANT SELECTOR
 */
function createVariantSelector(
    product,
    selectedVariant
) {

    var container =
        document.getElementById(
            "all_tangent_product_" +
            product.id
        );


    if (!container) {
        return;
    }


    container.innerHTML = "";


    var wrapper =
        document.createElement(
            "div"
        );

    wrapper.className =
        "tangent_checkout_variants_div";


    var currentVariant =
        selectedVariant ||
        product.variants[0];


    /*
     * CREATE VARIANT MAP
     */
    var variantMap = {};


    for (
        var vm = 0;
        vm < product.variants.length;
        vm++
    ) {

        var vmVariant =
            product.variants[vm];


        var vmKey =
            buildVariantKey(
                vmVariant.option1,
                vmVariant.option2,
                vmVariant.option3
            );


        variantMap[vmKey] =
            vmVariant;
    }


    option2_variant_map[product.id] =
        variantMap;


    /*
     * OPTION 1
     */
    createVariantOptionGroup(
        product,
        0,
        "tangent_options_1",
        "v1",
        currentVariant.option1,
        wrapper
    );


    /*
     * OPTION 2
     */
    createVariantOptionGroup(
        product,
        1,
        "tangent_options_2",
        "v2",
        currentVariant.option2,
        wrapper
    );


    /*
     * OPTION 3
     */
    createVariantOptionGroup(
        product,
        2,
        "tangent_options_3",
        "v3",
        currentVariant.option3,
        wrapper
    );


    container.appendChild(
        wrapper
    );
}


/*
 * CREATE ONE OPTION GROUP
 */
function createVariantOptionGroup(
    product,
    optionIndex,
    optionClass,
    optionSuffix,
    selectedValue,
    wrapper
) {

    if (
        !product.options ||
        !product.options[optionIndex] ||
        !product.options[optionIndex].values
    ) {
        return;
    }


    var option =
        product.options[
            optionIndex
        ];


    var optionDiv =
        document.createElement(
            "div"
        );

    optionDiv.className =
        "tangent_option_div";


    var optionName =
        document.createElement(
            "p"
        );

    optionName.className =
        "tangent_option_name";


    optionName.innerHTML =
        escapeHtml(
            option.name ||
            "Option"
        ) +
        ":";


    optionDiv.appendChild(
        optionName
    );


    for (
        var i = 0;
        i < option.values.length;
        i++
    ) {

        var optionElement =
            document.createElement(
                "p"
            );


        /*
         * IMPORTANT:
         * These classes are required by
         * changePdtVariant().
         */
        optionElement.className =
            "tangent_option " +
            optionClass +
            " all_product_" +
            product.id +
            optionSuffix;


        optionElement.id =
            "all_product_" +
            product.id +
            ":option_" +
            i;


        optionElement.innerHTML =
            escapeHtml(
                option.values[i]
            );


        /*
         * DEFAULT SELECTED OPTION
         */
        if (
            selectedValue != null &&
            String(selectedValue) ===
            String(option.values[i])
        ) {

            optionElement.classList.add(
                "tangent_selected-variant"
            );
        }


        optionDiv.appendChild(
            optionElement
        );
    }


    wrapper.appendChild(
        optionDiv
    );
}


/*
 * BUILD VARIANT KEY
 */
function buildVariantKey(
    option1,
    option2,
    option3
) {

    var key = "";


    if (
        option1 != null &&
        option1 != ""
    ) {

        key =
            String(option1);
    }


    if (
        option2 != null &&
        option2 != ""
    ) {

        key =
            key +
            "_" +
            String(option2);
    }


    if (
        option3 != null &&
        option3 != ""
    ) {

        key =
            key +
            "_" +
            String(option3);
    }


    return key;
}


/*
 * ESCAPE HTML
 */
function escapeHtml(value) {

    if (value == null) {
        return "";
    }


    return String(value)

        .replace(
            /&/g,
            "&amp;"
        )

        .replace(
            /</g,
            "&lt;"
        )

        .replace(
            />/g,
            "&gt;"
        )

        .replace(
            /"/g,
            "&quot;"
        )

        .replace(
            /'/g,
            "&#039;"
        );
}


/*
 * CHECK VARIANT AVAILABILITY
 */
function isVariantAvailable(
    variant
) {

    if (!variant) {
        return false;
    }


    /*
     * Shopify/API availability
     */
    if (
        variant.availableForSale === false
    ) {
        return false;
    }


    if (
        variant.available === false
    ) {
        return false;
    }


    /*
     * Inventory check
     */
    if (
        variant.inventory_policy == "deny" &&
        variant.inventory_management != null
    ) {

        if (
            Number(
                variant.inventory_quantity
            ) < 1
        ) {

            return false;
        }
    }


    return true;
}


/*
 * ADD ALL TO CART FUNCTION
 */
function addAllTocartFunction(type) {

    if (addToCartCount > 0) {

        switch(type) {

            case 'all':

                document
                    .getElementById(
                        'tangent-add-all-to-cart-all'
                    )
                    .setAttribute(
                        "href",
                        addAllToCartLink
                    );

                break;


            case 'basic':

                document
                    .getElementById(
                        'tangent-add-all-to-cart-basic'
                    )
                    .setAttribute(
                        "href",
                        addBasicToCartLink
                    );

                break;


            default:

                document
                    .getElementById(
                        'tangent-add-all-to-cart-work'
                    )
                    .setAttribute(
                        "href",
                        addWorkToCartLink
                    );
        }

    }

    else {

        var x =
            document.getElementById(
                "message-text"
            );


        if (x) {

            x.innerHTML =
                "We're currently sold out of the selected product(s). Please check back later!";

            x.className =
                "show";


            setTimeout(
                function () {

                    x.className =
                        x.className.replace(
                            "show",
                            ""
                        );

                },
                5000
            );
        }
    }
}


/*
 * TAB CLICK FUNCTION
 */
function clickHandle(
    evt,
    eName
) {

    let i,
        tabcontent,
        tablinks;


    tabcontent =
        document.getElementsByClassName(
            "tabcontent"
        );


    for (
        i = 0;
        i < tabcontent.length;
        i++
    ) {

        tabcontent[i].style.display =
            "none";
    }


    tablinks =
        document.getElementsByClassName(
            "tablinks"
        );


    for (
        i = 0;
        i < tablinks.length;
        i++
    ) {

        tablinks[i].className =
            tablinks[i].className.replace(
                " active",
                ""
            );
    }


    document
        .getElementById(eName)
        .style.display =
        "flex";


    evt.currentTarget.className +=
        " active";
}


/*
 * CHANGE PRODUCT VARIANT
 */
function changePdtVariant(ele) {

    if (
        !ele ||
        !ele.id ||
        !products
    ) {
        return;
    }


    var arr =
        ele.id.split(":");


    if (arr.length < 2) {
        return;
    }


    var productNumberText =
        arr[0];

    var optionNumberText =
        arr[1];

    var ele_type = "";

    var ele_Integer = 0;


    var type_start =
        productNumberText.indexOf(
            "product"
        );


    if (type_start < 0) {
        return;
    }


    ele_type =
        productNumberText.substring(
            0,
            type_start
        );


    /*
     * ALL PRODUCT
     */
    if (ele_type == "all_") {

        ele_Integer = 1;

        productNumberText =
            productNumberText.replace(
                "all_product_",
                ""
            );
    }


    /*
     * UPSELL PRODUCT
     */
    else if (ele_type == "upsell_") {

        ele_Integer = 2;

        productNumberText =
            productNumberText.replace(
                "upsell_product_",
                ""
            );
    }


    else {
        return;
    }


    var pId =
        parseInt(
            productNumberText,
            10
        );


    var pdt = null;


    /*
     * FIND PRODUCT
     */
    for (
        var p = 0;
        p < products.length;
        p++
    ) {

        if (
            String(products[p].id) ===
            String(pId)
        ) {

            pdt =
                products[p];

            break;
        }
    }


    if (
        !pdt ||
        !pdt.variants ||
        pdt.variants.length === 0
    ) {

        return;
    }


    var selectedOptionIndex =
        parseInt(
            optionNumberText.replace(
                "option_",
                ""
            ),
            10
        );


    var selectedValue =
        ele.innerHTML;


    /*
     * GET CURRENT VARIANT
     */
    var currentVariant = null;


    for (
        var cv = 0;
        cv < pdt.variants.length;
        cv++
    ) {

        if (
            String(
                pdt.variants[cv].id
            ) ===
            String(
                selected_pdt[pdt.id]
            )
        ) {

            currentVariant =
                pdt.variants[cv];

            break;
        }
    }


    if (!currentVariant) {

        currentVariant =
            pdt.variants[0];
    }


    /*
     * CURRENT OPTION VALUES
     */
    var opt1_value =
        currentVariant.option1;

    var opt2_value =
        currentVariant.option2;

    var opt3_value =
        currentVariant.option3;


    /*
     * CHANGE SELECTED OPTION
     */
    if (
        selectedOptionIndex >= 0
    ) {

        if (
            ele.classList.contains(
                "tangent_options_1"
            )
        ) {

            opt1_value =
                selectedValue;
        }

        else if (
            ele.classList.contains(
                "tangent_options_2"
            )
        ) {

            opt2_value =
                selectedValue;
        }

        else if (
            ele.classList.contains(
                "tangent_options_3"
            )
        ) {

            opt3_value =
                selectedValue;
        }
    }


    /*
     * CREATE NEW VARIANT KEY
     */
    var optionKey =
        buildVariantKey(
            opt1_value,
            opt2_value,
            opt3_value
        );


    var variantMap =
        option2_variant_map[
            pdt.id
        ] || {};


    var newVariant =
        variantMap[
            optionKey
        ];


    /*
     * IF COMBINATION DOES NOT EXIST
     * DO NOT CHANGE PRODUCT
     */
    if (!newVariant) {

        return;
    }


    /*
     * SAVE NEW VARIANT
     */
    selected_pdt[pdt.id] =
        String(
            newVariant.id
        );


    /*
     * HIGHLIGHT SELECTED OPTION
     */
    var optionPrefix = "";


    if (
        ele.classList.contains(
            "tangent_options_1"
        )
    ) {

        optionPrefix =
            "all_product_" +
            pId +
            "v1";
    }

    else if (
        ele.classList.contains(
            "tangent_options_2"
        )
    ) {

        optionPrefix =
            "all_product_" +
            pId +
            "v2";
    }

    else if (
        ele.classList.contains(
            "tangent_options_3"
        )
    ) {

        optionPrefix =
            "all_product_" +
            pId +
            "v3";
    }


    if (optionPrefix != "") {

        var optionElements =
            document.getElementsByClassName(
                optionPrefix
            );


        for (
            var oe = 0;
            oe < optionElements.length;
            oe++
        ) {

            optionElements[oe].classList.remove(
                "tangent_selected-variant"
            );
        }


        ele.classList.add(
            "tangent_selected-variant"
        );
    }


    /*
     * PRODUCT URL
     */
    var productUrl =
        domainUrl +
        "/products/" +
        pdt.handle +
        "?variant=" +
        newVariant.id;


    /*
     * PRODUCT IMAGE
     */
    var imageUrl =
        getVariantImage(
            newVariant.image_id,
            pdt
        );


    /*
     * AVAILABILITY
     */
    var available =
        pdt.status == "active" &&
        isVariantAvailable(
            newVariant
        );


    /*
     * PRODUCT ELEMENTS
     */
    var cartTextEle =
        document.getElementById(
            ele_type +
            "cart_tangent_product_" +
            pId +
            "_text"
        );


    var cartEle =
        document.getElementById(
            ele_type +
            "cart_tangent_product_" +
            pId
        );


    var productUrlEle =
        document.getElementById(
            ele_type +
            "url_tangent_product_" +
            pId
        );


    var productPriceEle =
        document.getElementById(
            ele_type +
            "price_tangent_product_" +
            pId
        );


    var productImageEle =
        document.getElementById(
            ele_type +
            "image_tangent_product_" +
            pId
        );


    /*
     * UPDATE URL
     */
    if (productUrlEle) {

        productUrlEle.href =
            productUrl;
    }


    /*
     * UPDATE PRICE
     */
    if (productPriceEle) {

        productPriceEle.innerHTML =
            domainCurrency +
            newVariant.price;
    }


    /*
     * UPDATE IMAGE
     */
    if (
        productImageEle &&
        imageUrl
    ) {

        productImageEle.src =
            imageUrl;
    }


    /*
     * UPDATE ADD TO CART TEXT
     */
    if (cartTextEle) {

        cartTextEle.classList.remove(
            "added-to-cart-style"
        );


        cartTextEle.innerHTML =
            available
                ? default_addToCartText
                : outOfStock;
    }


    /*
     * ENABLE / DISABLE ADD TO CART
     */
    if (cartEle) {

        if (available) {

            cartEle.classList.remove(
                "disable-btn-wrapper"
            );


            cartEle.setAttribute(
                "onclick",
                "addToCart(" +
                pId +
                "," +
                ele_Integer +
                ")"
            );

        }
        else {

            cartEle.classList.add(
                "disable-btn-wrapper"
            );
        }
    }


    /*
     * REBUILD ADD ALL CART URL
     */
    var cartIds = [];


    for (
        var cp = 0;
        cp < products.length;
        cp++
    ) {

        var cartProduct =
            products[cp];


        if (
            !cartProduct ||
            !cartProduct.variants ||
            cartProduct.variants.length === 0
        ) {

            continue;
        }


        var selectedId =
            selected_pdt[
                cartProduct.id
            ];


        var selectedVariant =
            null;


        for (
            var cvi = 0;
            cvi < cartProduct.variants.length;
            cvi++
        ) {

            if (
                String(
                    cartProduct.variants[cvi].id
                ) ===
                String(
                    selectedId
                )
            ) {

                selectedVariant =
                    cartProduct.variants[cvi];

                break;
            }
        }


        if (
            cartProduct.status == "active" &&
            selectedVariant &&
            isVariantAvailable(
                selectedVariant
            )
        ) {

            cartIds.push(
                selectedVariant.id
            );
        }
    }


    updateAllProductsCart(
        cartIds
    );
}


/*
 * FIND SELECTED VARIANT
 */
function isSelectedVariantPresent(
    selectedVariants,
    productId
) {

    if (!selectedVariants) {
        return [];
    }


    for (
        var key in selectedVariants
    ) {

        if (
            String(key) ===
            String(productId)
        ) {

            if (
                selectedVariants[key] == null
            ) {

                return [];
            }


            if (
                typeof selectedVariants[key] ===
                "string"
            ) {

                return [
                    selectedVariants[key]
                ];
            }


            if (
                Array.isArray(
                    selectedVariants[key]
                )
            ) {

                return selectedVariants[key];
            }
        }
    }


    return [];
}


/*
 * GET VARIANT IMAGE
 */
const getVariantImage =
    (imageId, product) => {

        var pdtImg;


        if (imageId != null) {

            var all_images =
                product.images;


            if (
                all_images != undefined
            ) {

                for (
                    var im = 0;
                    im < all_images.length;
                    im++
                ) {

                    if (
                        imageId ==
                        all_images[im].id
                    ) {

                        pdtImg =
                            all_images[im].src;
                    }
                }
            }
        }

        else {

            if (
                product.image != null
            ) {

                pdtImg =
                    product.image.src;
            }

            else {

                pdtImg =
                    "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp";
            }
        }


        if (
            pdtImg == undefined ||
            pdtImg == null
        ) {

            pdtImg =
                "https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp";
        }


        return pdtImg;
    };


/*
 * ADD SINGLE PRODUCT TO CART
 */
function addToCart(
    id,
    status
) {

    var pdtid =
        Number(id);


    var pid =
        selected_pdt[pdtid];


    var section =
        "all_";


    if (status == 1) {

        section =
            "basic_";
    }

    else if (status == 2) {

        section =
            "work_";
    }

    else {

        section =
            "all_";
    }


    var data = {

        "id": pid,

        "quantity": 1
    };


    jQuery.ajax({

        type: "POST",

        url: "/cart/add.js",

        data: data,

        dataType: "json",


        success: function() {

            var elemID =
                section +
                "cart_tangent_product_" +
                id +
                "_text";


            var element =
                document.getElementById(
                    elemID
                );


            if (
                element != undefined
            ) {

                element.innerHTML =
                    "Added to Cart!";


                element.classList.add(
                    "added-to-cart-style"
                );
            }


            document.dispatchEvent(
                new CustomEvent(
                    "cart:build",
                    {
                        bubbles: true
                    }
                )
            );


            document.dispatchEvent(
                new CustomEvent(
                    "cart:refresh",
                    {
                        bubbles: true
                    }
                )
            );
        },


        error: function(
            XMLHttpRequest,
            textStatus,
            errorThrown
        ) {

            console.log(
                "Error on adding to cart",
                textStatus
            );


            Shopify.onError(
                XMLHttpRequest,
                textStatus
            );
        }
    });
}


/*
 * LOADING TEXT
 */
function changeLoadingText(txt) {

    // document.getElementById("loading_text").innerHTML = txt;

}